import React from 'react'
import { IconProps } from './types'

export const AreaOcrIcon: React.FC<IconProps> = ({
  size = 24,
  strokeWidth = 2,
  primaryColor = 'currentColor',
  className,
  title,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={primaryColor}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    role="img"
    aria-label={title}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M14 3v4a1 1 0 0 0 1 1h4" />
    <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" />
    <rect x="7.5" y="9.5" width="9" height="7" rx="1" />
    <line x1="7.5" y1="13" x2="16.5" y2="13" />
    <line x1="12" y1="9.5" x2="12" y2="16.5" />
    <circle cx="11" cy="12" r="0.5" fill="currentColor" />
  </svg>
)
